import axios from "axios";
// 获取系统信息
export const systemInfo = params => {
    let res = async function () {
        return get(httpUrl + "/system/currentSystem");
    }
    return res();
};
// 修改系统信息
export const updateSystem = params => {
    return axios.post(httpUrl + "/system/updateSystem", params);
};

// 获取验证码
export const getCode = params => {
    return axios.get(httpUrl + "/getCaptcha");
};
// 登录
export const loginServer = params => {
    return axios.post(httpUrl + "/auth/login", params);
};
export const encryptLogin = params => {
    return axios.post(httpUrl + "/auth/encryptLogin", params);
};
// 注销
export const loginOut = params => {
    return axios.post(httpUrl + "/auth/logout");
};
// 文件上传
export const uploadFile = params => {
    return axios.post(httpUrl + "/file/files/upload", params);
};
// 获取菜单
export const getMenu = params => {
    return axios.post(httpUrl + "/system/menu/menuTree", params);
};
export const addMenu = params => {
    return axios.post(httpUrl + "/system/menu/addMenu", params);
};
export const delMenu = params => {
    return axios.post(httpUrl + "/system/menu/delByMenuId", params);
};
export const editMenu = params => {
    return axios.post(httpUrl + "/system/menu/updateMenu", params);
};
export const getRouters = params => {
    return axios.get(httpUrl + "/system/menu/getRouters", params);
};
// 设置语言
export const setLanguage = params => {
    return axios.post(httpUrl + "/system/user/updateLanguage", params);
};
// 获取用户列表
export const getUser = params => {
    return axios.post(httpUrl + "/system/user/listPage", params);
};
export const getUserInfo = params => {
    return axios.post(httpUrl + "/system/user/findByUserId", params);
};
export const addUser = params => {
    return axios.post(httpUrl + "/system/user/addUser", params);
};
export const updateUser = params => {
    return axios.post(httpUrl + "/system/user/updateUser", params);
};
export const delUser = params => {
    return axios.post(httpUrl + "/system/user/delByUserIds", params);
};
export const updateUserRole = params => {
    return axios.post(httpUrl + "/system/user/updateUserRole", params);
};
export const updateInfo = params => {
    return axios.post(httpUrl + "/system/user/updateInfo", params);
};
export const updatePwd = params => {
    return axios.post(httpUrl + "/system/user/updatePwd", params);
};
export const userLogListPage = params => {
    return axios.post(httpUrl + "/system/user/userLogListPage", params);
};
export const downVehicleQrCode = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/downVehicleQrCode", params);
};

// 地图API
export const getMapInfo = params => {
    return axios.post(httpUrl + "/monitor-service/map/findMap", params);
};
export const getAllMap = params => {
    params.mapEnable="Y";
    return axios.post(httpUrl + "/monitor-service/map/listData", params);
};
export const importMap = params => {
    return axios.post(httpUrl + "/monitor-service/map/importMap", params, { responseType: 'blob' });
};
export const saveMapInfo = params => {
    if(params.mapId){
        return axios.post(httpUrl + "/monitor-service/map/updateMap", params);
    }else{
        return axios.post(httpUrl + "/monitor-service/map/saveMap", params);
    }
};
export const delMap = params => {
    return axios.post(httpUrl + "/monitor-service/map/delMap", params);
};
export const getMapList = params => {
    return axios.post(httpUrl + "/monitor-service/map/listPage", params);
};
// 实时定位
export const currentPosition = params => {
    return axios.post(httpUrl + "/position/currentPosition/findList", params);
};

// 历史轨迹
export const historyPosition = params => {
    return axios.post(httpUrl + "/position/historyPosition/findArray", params);
};
export const historyPositions = params => {
    return axios.post(httpUrl + "/position/historyPosition/findList", params);
};
export const findPersonHistoryList = params => {
    return axios.post(httpUrl + "/position/historyPosition/findPersonHistoryList", params);
};
export const findVisitorHistoryList = params => {
    return axios.post(httpUrl + "/position/historyPosition/findVisitorHistoryList", params);
};
// 楼宇管理
export const listBuilding = params => {
    return axios.post(httpUrl + "/device/building/listPage", params);
};
export const findBuilding = params => {
    return axios.post(httpUrl + "/device/building/findBuilding", params);
};
export const previewBuilding = params => {
    return axios.post(httpUrl + "/device/building/listBuilding", params);
};
export const addBuilding = params => {
    return axios.post(httpUrl + "/device/building/addBuilding", params);
};
export const updateBuilding = params => {
    return axios.post(httpUrl + "/device/building/updateBuilding", params);
};
export const delBuilding = params => {
    return axios.post(httpUrl + "/device/building/delBuilding", params);
};
export const saveBuilding = params => {
    return axios.post(httpUrl + "/device/building/saveBuilding", params);
};
export const importBuilding = params => {
    return axios.post(httpUrl + "/device/building/importBuilding", params, { responseType: 'blob' });
};

//

// 楼层管理
export const listLayer = params => {
    return axios.post(httpUrl + "/device/layer/listPage", params);
};
export const findLayer = params => {
    return axios.post(httpUrl + "/device/layer/findLayer", params);
};
export const previewLayer = params => {
    return axios.post(httpUrl + "/device/layer/listLayer", params);
};
export const addLayer = params => {
    return axios.post(httpUrl + "/device/layer/addLayer", params);
};
export const updateLayer = params => {
    return axios.post(httpUrl + "/device/layer/updateLayer", params);
};
export const delLayer = params => {
    return axios.post(httpUrl + "/device/layer/delLayer", params);
};
export const saveLayer = params => {
    return axios.post(httpUrl + "/device/layer/saveLayer", params);
};
export const importLayer = params => {
    return axios.post(httpUrl + "/device/layer/importLayer", params, { responseType: 'blob' });
};

// 信标API
export const listBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/listPage", params);
};
export const findBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/findBeacon", params);
};
export const previewBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/preview", params);
};
export const addBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/addBeacon", params);
};
export const updateBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/updateBeacon", params);
};
export const delBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/delBeacon", params);
};
export const saveBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/saveBeacon", params);
};
export const importBeacon = params => {
    return axios.post(httpUrl + "/device/beacon/importBeacon", params);
};
export const importBeaconUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/beacon/importUpdateBeacon", params);
    // return axios.post(httpUrl + "/device/beacon/importBeaconUpdate", params, { responseType: 'blob' });
};
// UWB基站API
export const UWBlistBeacon = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/listPage", params);
};
export const importUWB = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/importUwbStation", params);
};
export const updateUWB = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/updateUwbStation", params);
};

export const previewUWB = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/preview", params);
};

export const saveUWB = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/saveUwbStation", params);
};

export const UWBdelStation = params => {
    return axios.post(httpUrl + "/monitor-service/uwbStation/delUwbStation", params);
};

// 闸机大屏
export const getArea = params => {
    return axios.get(httpUrl + "/monitor-service/gateManage/getGateAreaList", params);
};

export const getList = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/getAreaStaffRecord", params);
};

export const leave = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/personnelLeavingArea", params);
};

// 基站API
export const listStation = params => {
    return axios.post(httpUrl + "/device/station/listPage", params);
};
export const findStation = params => {
    return axios.post(httpUrl + "/device/station/findStation", params);
};
export const previewStation = params => {
    return axios.post(httpUrl + "/device/station/preview", params);
};
export const addStation = params => {
    return axios.post(httpUrl + "/device/station/addStation", params);
};
export const updateStation = params => {
    return axios.post(httpUrl + "/device/station/updateStation", params);
};
export const delStation = params => {
    return axios.post(httpUrl + "/device/station/delStation", params);
};
export const saveStation = params => {
    return axios.post(httpUrl + "/device/station/saveStation", params);
};

// 定位卡管理
export const listCard = params => {
    return axios.post(httpUrl + "/device/card/listPage", params);
};
export const findCard = params => {
    return axios.post(httpUrl + "/device/card/findCard", params);
};
export const addCard = params => {
    return axios.post(httpUrl + "/device/card/addCard", params);
};
export const updateCard = params => {
    return axios.post(httpUrl + "/device/card/updateCard", params);
};
export const delCard = params => {
    return axios.post(httpUrl + "/device/card/delCard", params);
};
export const findCardData = params => {
    return axios.post(httpUrl + "/device/card/cardList", params);
};
export const importCard = params => {
    return axios.post(httpUrl + "/device/card/importCard", params);
};

// 摄像头API
export const listCamera = params => {
    return axios.post(httpUrl + "/device/camera/listPage", params);
};
export const findCamera = params => {
    return axios.post(httpUrl + "/device/camera/findCamera", params);
};
export const previewCamera = params => {
    return axios.post(httpUrl + "/device/camera/preview", params);
};
export const addCamera = params => {
    return axios.post(httpUrl + "/device/camera/addCamera", params);
};
export const updateCamera = params => {
    return axios.post(httpUrl + "/device/camera/updateCamera", params);
};
export const delCamera = params => {
    return axios.post(httpUrl + "/device/camera/delCamera", params);
};
// 摄像头导入
export const importCamera = params => {
    return axios.post(httpUrl + "/device/camera/importCamera", params, { responseType: 'blob' });
};

// 电子围栏API
export const listRail = params => {
    return axios.post(httpUrl + "/system/rail/listPage", params);
};
export const findRail = params => {
    return axios.post(httpUrl + "/system/rail/findRail", params);
};
export const addRail = params => {
    return axios.post(httpUrl + "/system/rail/addRail", params);
};
export const updateRail = params => {
    return axios.post(httpUrl + "/system/rail/updateRail", params);
};
export const delRail = params => {
    return axios.post(httpUrl + "/system/rail/delRail", params);
};
export const previewRail = params => {
    return axios.post(httpUrl + "/system/rail/findData", params);
};

// 风险分区API
export const listRisk = params => {
    return axios.post(httpUrl + "/system/risk/listPage", params);
};
export const findRisk = params => {
    return axios.post(httpUrl + "/system/risk/findRisk", params);
};
export const addRisk = params => {
    return axios.post(httpUrl + "/system/risk/addRisk", params);
};
export const updateRisk = params => {
    return axios.post(httpUrl + "/system/risk/updateRisk", params);
};
export const delRisk = params => {
    return axios.post(httpUrl + "/system/risk/delRisk", params);
};
export const previewRisk = params => {
    return axios.post(httpUrl + "/system/risk/findData", params);
};
// SOS报警通知设置详情
export const findSOSAlarmNotice = params => {
    return axios.get(httpUrl + "/system/alarm/notice/sos/findConfig", params);
};
export const updateSOSAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/sos/updateConfig", params);
};

// 报警通知API
export const listAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/listPage", params);
};
export const findAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/findAlarmNotice", params);
};
export const addAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/addAlarmNotice", params);
};
export const updateAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/updateAlarmNotice", params);
};
export const delAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/delAlarmNotice", params);
};
export const previewAlarmNotice = params => {
    return axios.post(httpUrl + "/system/alarm/notice/findData", params);
};

// 人员报警设置 API
export const listAlarmPersonSet = params => {
    return axios.post(httpUrl + "/system/area/listPage", params);
};
export const findAlarmPersonSet = params => {
    return axios.post(httpUrl + "/system/area/findArea", params);
};
export const addAlarmPersonSet = params => {
    return axios.post(httpUrl + "/system/area/addArea", params);
};
export const updateAlarmPersonSet = params => {
    return axios.post(httpUrl + "/system/area/updateArea", params);
};
export const delAlarmPersonSet = params => {
    return axios.post(httpUrl + "/system/area/delArea", params);
};


// 人员报警列表
export const alarmPsListPage = params => {
    return axios.post(httpUrl + "/system/alarm/person/listPage", params);
};
export const findAlarmPeople = params => {
    return axios.post(httpUrl + "/system/alarm/person/findAlarmPeople", params);
};
export const alarmPeopleStatistics = params => {
    return axios.post(httpUrl + "/statistics/alarmStatistics/alarmAreaStatistics", params);
};
export const findAlarmPsFind = params => {
    return axios.post(httpUrl + "/system/alarm/person/findAlarm", params);
};
export const disposeAlarm = params => {
    return axios.post(httpUrl + "/system/alarm/person/disposeAlarm", params);
};
export const delAlarmPsList = params => {
    return axios.post(httpUrl + "/system/alarm/person/delAlarm", params);
};
export const statisticByDay = params => {
    return axios.post(httpUrl + "/work-service/workMAlarm/statisticByDay", params);
};
export const disposeCardAlarm = params => {
    return axios.post(
        httpUrl + "/monitor-service/alarm/person/disposeCardAlarm",
        params
    );
};

// 角色API
export const listRole = params => {
    return axios.post(httpUrl + "/system/role/listPage", params);
};
export const findRole = params => {
    return axios.post(httpUrl + "/system/role/findRole", params);
};
export const addRole = params => {
    return axios.post(httpUrl + "/system/role/addRole", params);
};
export const updateRole = params => {
    return axios.post(httpUrl + "/system/role/updateRole", params);
};
export const delRole = params => {
    return axios.post(httpUrl + "/system/role/delRole", params);
};
export const authRole = params => {
    return axios.post(httpUrl + "/system/role/authRole", params);
};
export const findRoleData = params => {
    return axios.post(httpUrl + "/system/role/findData", params);
};

// 部门API
export const listDept = params => {
    return axios.post(httpUrl + "/system/dept/deptTree", params);
};
export const findDept = params => {
    return axios.post(httpUrl + "/system/dept/findDept", params);
};
export const addDept = params => {
    return axios.post(httpUrl + "/system/dept/addDept", params);
};
export const updateDept = params => {
    return axios.post(httpUrl + "/system/dept/updateDept", params);
};
export const delDept = params => {
    return axios.post(httpUrl + "/system/dept/delDept", params);
};
export const importDept = params => {
    return axios.post(httpUrl + "/system/dept/importDept", params);
};

// 区域统计
export const regionList = params => {
    return axios.post(
        httpUrl + "/monitor-service/railStatistics/regionPerson",
        params
    );
};
// 重大风险分区统计
export const riskPerson = params => {
    return axios.post(
        httpUrl + "/monitor-service/railStatistics/riskPerson",
        params
    );
};
export const regionAdd = params => {
    return axios.post(httpUrl + "/monitor-service/region/addRegion", params);
};
export const regionListPage = params => {
    return axios.post(httpUrl + "/monitor-service/region/listPage", params);
};

export const delRegion = params => {
    return axios.post(httpUrl + "/monitor-service/region/delRegion", params);
};

export const findRegion = params => {
    return axios.post(httpUrl + "/monitor-service/region/findRegion", params);
};
export const updateRegion = params => {
    return axios.post(httpUrl + "/monitor-service/region/updateRegion", params);
};

// 职位管理
export const listPost = params => {
    return axios.post(httpUrl + "/system/post/listPage", params);
};
export const findPost = params => {
    return axios.post(httpUrl + "/system/post/findByPostId", params);
};
export const addPost = params => {
    return axios.post(httpUrl + "/system/post/addPost", params);
};
export const updatePost = params => {
    return axios.post(httpUrl + "/system/post/updatePost", params);
};
export const delPost = params => {
    return axios.post(httpUrl + "/system/post/delByPostIds", params);
};
export const findPostData = params => {
    return axios.post(httpUrl + "/system/post/findData", params);
};
export const importPost = params => {
    return axios.post(httpUrl + "/system/post/importPost", params);
};

// 字典管理
export const listDict = params => {
    return axios.post(httpUrl + "/system/dict/listPage", params);
};
export const findDict = params => {
    return axios.post(httpUrl + "/system/dict/findDict", params);
};
export const addDict = params => {
    return axios.post(httpUrl + "/system/dict/addDict", params);
};
export const updateDict = params => {
    return axios.post(httpUrl + "/system/dict/updateDict", params);
};
export const delDict = params => {
    return axios.post(httpUrl + "/system/dict/delDict", params);
};
export const findDictType = params => {
    return axios.post(httpUrl + "/system/dict/findDictType", params);
};
export const findDictData = params => {
    return axios.post(httpUrl + "/system/dict/findData", params);
};

// 日志管理
export const loginListPage = params => {
    return axios.post(httpUrl + "/system/log/loginListPage", params);
};
export const operateListPage = params => {
    return axios.post(httpUrl + "/system/log/operateListPage", params);
};

// 查询所有人员
export const listAllPersonPage = params => {
    return axios.post(httpUrl + "/person/allPerson/listPage", params);
};

// 获取系统自定义列表
export const getListSystem = params => {
    return axios.post(httpUrl + "/monitor-service/customSystemConfig/listPage", params);
};

// 修改系统自定义配置
export const changeSystemConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSystemConfig/update", params);
};

// 新增系统自定义配置
export const createSystemConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSystemConfig/create", params);
};

// 系统自定义配置导出
export const exportSystemConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSystemConfig/export", params, { responseType: 'blob' });
};

// 获取当前自定义配置--系统
export const getSystemConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSelfConfig/findCustomConfig", params);
};

// 获取当前自定义配置--个人
export const getPersonConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSelfConfig/listPage", params);
};

// 新增当前自定义配置--个人
export const createPersonConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSelfConfig/create", params);
};

// 修改当前自定义配置--个人
export const changePersonConfiguration = params => {
    return axios.post(httpUrl + "/monitor-service/customSelfConfig/update", params);
};

export const listAllPersons = params => {
    return axios.post(httpUrl + "/person/allPerson/findData", params);
};
export const listAllPerson = params => {
    return axios.post(httpUrl + "/person/allPerson/simplifyPerson", params);
};
export const importPersonCard = params => {
    return axios.post(httpUrl + "/monitor-service/allPerson/importPersonCard", params, { responseType: 'blob' });
};

export const emergencyEvacuation = params => {
    return axios.post(httpUrl + "/monitor-service/allPerson/emergencyEvacuation", params);
};

export const personPositionList = params => {
    return axios.post(
        httpUrl + "/monitor-service/historyPosition/personPositionList",
        params
    );
};
export const personRegister = params => {
    return axios.post(
        httpUrl + "/monitor-service/user/personRegister",
        params
    );
};

// 导入人员
export const batchImport = params => {
    return axios.post(httpUrl + "/person/allPerson/batchImport", params);
};

// 员工管理
export const listStaff = params => {
    return axios.post(httpUrl + "/person/staff/listPage", params);
};
export const findStaff = params => {
    return axios.post(httpUrl + "/person/staff/findStaff", params);
};
export const addStaff = params => {
    return axios.post(httpUrl + "/person/staff/addStaff", params);
};
export const updateStaff = params => {
    return axios.post(httpUrl + "/person/staff/updateStaff", params);
};
export const delStaff = params => {
    return axios.post(httpUrl + "/person/staff/delStaff", params);
};
export const retuningStaff = params => {
    return axios.post(httpUrl + "/person/staff/retuning", params);
};
export const dimissionStaff = params => {
    return axios.post(httpUrl + "/person/staff/dimission", params);
};
export const importStaff = params => {
    return axios.post(httpUrl + "/monitor-service/staff/importStaff", params);
};
export const importStaffUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/staff/importStaffUpdate", params);
};
export const importPhoto = params => {
    return axios.post(httpUrl + "/monitor-service/allPerson/importPersonPhoto", params);
};
export const downLoadFileExport = params => {
    return axios.post(httpUrl + "/monitor-service/files/downLoadFileExport", params, { responseType: 'blob' });
};
// 访客管理
export const listVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/listPage", params);
};
export const findVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/findVisitor", params);
};
export const addVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/addVisitor", params);
};
export const updateVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/updateVisitor", params);
};
export const delVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/delVisitor", params);
};
export const givebackVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/giveback", params);
};
export const importVisitor = params => {
    return axios.post(httpUrl + "/person/visitor/importVisitor", params);
};
export const importVisitorUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/visitor/importVisitorUpdate", params);
};

// 承包商管理
export const listContractor = params => {
    return axios.post(httpUrl + "/person/contractor/listPage", params);
};
export const findContractor = params => {
    return axios.post(httpUrl + "/person/contractor/findContractor", params);
};
export const addContractor = params => {
    return axios.post(httpUrl + "/person/contractor/addContractor", params);
};
export const updateContractor = params => {
    return axios.post(httpUrl + "/person/contractor/updateContractor", params);
};
export const delContractor = params => {
    return axios.post(httpUrl + "/person/contractor/delContractor", params);
};
export const importContractor = params => {
    return axios.post(httpUrl + "/person/contractor/importContractor", params);
};

// 外来施工人员
export const listMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/migrantListPage", params);
};
export const findMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/findMigrant", params);
};
export const addMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/addMigrant", params);
};
export const updateMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/updateMigrant", params);
};
export const delMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/delMigrant", params);
};
export const importMigrant = params => {
    return axios.post(httpUrl + "/person/contractor/importMigrant", params);
};
export const importMigrantUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/contractor/importMigrantUpdate", params);
};

// 监控
export const getPlayPath = params => {
    return axios.post(params.url + "/play", params.data);
};
export const playAlive = params => {
    return axios.post(params.url + "/playAlive", params.data);
};

// 实时定位统计（人员类型、部门人员）
export const realtimeChartData = params => {
    return axios.post(
        httpUrl + "/statistics/positionStatistics/currentStatistics",
        params
    );
};
export const currentPrimaryDeptStatistics = params => {
    return axios.post(
        httpUrl + "/statistics/positionStatistics/currentPrimaryDeptStatistics",
        params
    );
};
// 今日报警统计（今日报警数据概览）
export const todayAlarm = params => {
    return axios.post(httpUrl + "/statistics/alarmStatistics/todayAlarm", params);
};

// 报警统计 （默认当月数据）
export const monthAlarm = params => {
    return axios.post(httpUrl + "/statistics/alarmStatistics/monthAlarm", params);
};
// (今日、昨日、上周同日)人员出勤统计（今日人员数据概览）
export const todayPerson = params => {
    return axios.post(
        httpUrl + "/statistics/personStatistics/todayPerson",
        params
    );
};
// 人员周统计（大屏、默认近5天）
export const daysPerson = params => {
    return axios.post(
        httpUrl + "/statistics/personStatistics/daysPerson",
        params
    );
};
// 人员流量统计（默认近7天）
export const monthPerson = params => {
    return axios.post(
        httpUrl + "/statistics/personStatistics/monthPerson",
        params
    );
};
// 员工占比
export const staffStatistics = params => {
    return axios.post(
        httpUrl + "/statistics/personStatistics/staffStatistics",
        params
    );
};
// 报警统计(大屏、默认今天)
export const dateAlarm = params => {
    return axios.post(httpUrl + "/statistics/alarmStatistics/dateAlarm", params);
};

// 大屏设置
export const listLargeScreen = params => {
    return axios.post(httpUrl + "/system/largeScreen/listLargeScreen", params);
};
export const addLargeScreen = params => {
    return axios.post(httpUrl + "/system/largeScreen/addLargeScreen", params);
};
export const updateLargeScreen = params => {
    return axios.post(httpUrl + "/system/largeScreen/updateLargeScreen", params);
};
export const delLargeScreen = params => {
    return axios.post(httpUrl + "/system/largeScreen/delLargeScreen", params);
};
export const updateLargeScreenChecked = params => {
    return axios.post(
        httpUrl + "/system/largeScreen/updateLargeScreenChecked",
        params
    );
};

// 车辆相关
export const syncVehicle = params => {
    return axios.get(httpUrl + "/device/vehicle/syncVehicle", params);
};
export const carlistPage = params => {
    return axios.post(httpUrl + "/device/vehicle/listPage", params);
};
export const findVehicle = params => {
    return axios.post(httpUrl + "/device/vehicle/findVehicle", params);
};
export const updateVehicle = params => {
    return axios.post(httpUrl + "/device/vehicle/updateVehicle", params);
};
export const delVehicle = params => {
    return axios.post(httpUrl + "/device/vehicle/delVehicle", params);
};
// 车辆围栏
export const vehicleRailListPage = params => {
    return axios.post(httpUrl + "/device/vehicle/vehicleRailListPage", params);
};
export const addVehicleRail = params => {
    return axios.post(httpUrl + "/device/vehicle/addVehicleRail", params);
};
export const updateVehicleRail = params => {
    return axios.post(httpUrl + "/device/vehicle/updateVehicleRail", params);
};
export const deleteVehicleRail = params => {
    return axios.post(httpUrl + "/device/vehicle/deleteVehicleRail", params);
};
// 车辆历史轨迹
export const historyPositionList = params => {
    return axios.post(httpUrl + "/device/vehicle/historyPositionList", params);
};
export const vehicleHistory = params => {
    return axios.post(httpUrl + "/device/vehicle/vehicleHistory", params);
};

// 围栏绑定的车辆
export const railVehicleListPage = params => {
    return axios.post(httpUrl + "/device/vehicle/railVehicleListPage", params);
};
export const bindingVehicle = params => {
    return axios.post(httpUrl + "/device/vehicle/bindingVehicle", params);
};
export const unboundVehicle = params => {
    return axios.post(httpUrl + "/device/vehicle/unboundVehicle", params);
};

// 车辆报警列表
export const vehicleAlarmList = params => {
    return axios.post(httpUrl + "/device/vehicle/vehicleAlarmListPage", params);
};
export const batchMarkReadAlarm = params => {
    return axios.post(httpUrl + "/device/vehicle/disposeVehicleAlarm", params);
};

// 车辆报警类型走势统计（默认当月）
export const vehicleStatisticsTrend = params => {
    return axios.post(httpUrl + "/device/vehicle/vehicleStatisticsTrend", params);
};
// 车辆报警类型统计比较（今日，较昨日，较上周同日）
export const vehicleAlarmStatisticsCompare = params => {
    return axios.get(
        httpUrl + "/device/vehicle/vehicleAlarmStatisticsCompare",
        params
    );
};
// 车辆数量统计
export const vehicleCountStatistics = params => {
    return axios.get(httpUrl + "/device/vehicle/vehicleCountStatistics", params);
};
// 车辆报警类型统计(默认今天：适用于大屏，或指定日期)
export const vehicleAlarmStatisticsByDay = params => {
    return axios.post(
        httpUrl + "/device/vehicle/vehicleAlarmStatisticsByDay",
        params
    );
};
// 车辆实时定位
export const currentPositionList = params => {
    return axios.post(httpUrl + "/device/vehicle/currentPositionList", params);
};

// 手表管理
export const findAllWatch = params => {
    return axios.post(httpUrl + "/device/watch/listPage", params);
};
export const addWatch = params => {
    return axios.post(httpUrl + "/device/watch/insertWatch", params);
};
export const updateWatch = params => {
    return axios.post(httpUrl + "/device/watch/updateWatch", params);
};
export const delByWatchIds = params => {
    return axios.post(httpUrl + "/device/watch/delByWatchIds", params);
};
export const importWatch = params => {
    return axios.post(httpUrl + "/device/watch/importWatch", params);
};
export const findWatchData = params => {
    return axios.post(httpUrl + "/device/watch/findData", params);
};
export const findByWatchId = params => {
    return axios.post(httpUrl + "/device/watch/findByWatchId", params);
};

// 所有定位设备
export const findPositionDeviceData = params => {
    return axios.post(
        httpUrl + "/device/allDevice/findPositionDeviceData",
        params
    );
};

//巡检项管理
export const inspectList = params => {
    return axios.post(httpUrl + "/inspect-service/item/listPage", params);
};
export const exportServiceItem = params => {
    return axios.post(httpUrl + "/inspect-service/item/exportItem", params);
};
export const importServiceItem = params => {
    return axios.post(httpUrl + "/inspect-service/item/importItem", params, { responseType: 'blob' });
};
export const addItemServiceItem = params => {
    return axios.post(httpUrl + "/inspect-service/item/addItem", params);
};
export const servicedelItem = params => {
    return axios.post(httpUrl + "/inspect-service/item/delItem", params);
};
export const findByItemIdlItem = params => {
    return axios.post(httpUrl + "/inspect-service/item/findByItemId", params);
};
export const listItemInspect = params => {
    return axios.post(httpUrl + "/inspect-service/item/listItem", params);
};
export const updateItemInspect = params => {
    return axios.post(httpUrl + "/inspect-service/item/updateItem", params);
};

//巡检点管理
export const previewPoint = params => {
    return axios.post(httpUrl + "/inspect-service/location/listLocation", params);
};
export const inspectSpot = params => {
    return axios.post(httpUrl + "/inspect-service/location/listPage", params);
};
export const addPatrolPoint = params => {
    return axios.post(httpUrl + "/inspect-service/location/addLocation", params);
};
export const delPatrolPoint = params => {
    return axios.post(httpUrl + "/inspect-service/location/delLocation", params);
};
export const exportPatrolPoint = params => {
    return axios.post(
        httpUrl + "/inspect-service/location/exportLocation",
        params
    );
};
export const seeFindLocation = params => {
    return axios.post(httpUrl + "/inspect-service/location/findLocation", params);
};
export const importServiceLocation = params => {
    return axios.post(
        httpUrl + "/inspect-service/location/importLocation",
        params
    );
};
export const editUpdateLocation = params => {
    return axios.post(
        httpUrl + "/inspect-service/location/updateLocation",
        params
    );
};

//巡检类别管理
export const patrolClassList = params => {
    return axios.post(httpUrl + "/inspect-service/type/listPage", params);
};
export const patrolClassAddType = params => {
    return axios.post(httpUrl + "/inspect-service/type/addType", params);
};
export const patrolClassDeltype = params => {
    return axios.post(httpUrl + "/inspect-service/type/delType", params);
};
export const patrolClassimportType = params => {
    return axios.post(httpUrl + "/inspect-service/type/importType", params, { responseType: 'blob' });
};
export const patrolClassfindType = params => {
    return axios.post(httpUrl + "/inspect-service/type/findType", params);
};
export const patrolClassupdateType = params => {
    return axios.post(httpUrl + "/inspect-service/type/updateType", params);
};
export const patrolClassListType = params => {
    return axios.post(httpUrl + "/inspect-service/type/listType", params);
};

//巡检班组管理
export const PatrolInspectionTeamListPage = params => {
    return axios.post(httpUrl + "/inspect-service/team/listPage", params);
};
export const PatrolInspectionTeamadd = params => {
    return axios.post(httpUrl + "/inspect-service/team/addTeam", params);
};
export const PatrolInspectionSee = params => {
    return axios.post(httpUrl + "/inspect-service/team/findTeam", params);
};
export const PatrolInspectionModify = params => {
    return axios.post(httpUrl + "/inspect-service/team/updateTeam", params);
};
export const PatrolInspectionDelTeam = params => {
    return axios.post(httpUrl + "/inspect-service/team/delTeam", params);
};
export const PatrolInspectionTeamListTeam = params => {
    return axios.post(httpUrl + "/inspect-service/team/listTeam", params);
};

//巡检路线管理
export const routeList = params => {
    return axios.post(httpUrl + "/inspect-service/road/listPage", params);
};
export const routeAdd = params => {
    return axios.post(httpUrl + "/inspect-service/road/addRoad", params);
};
export const routeLel = params => {
    return axios.post(httpUrl + "/inspect-service/road/delRoad", params);
};
export const routeFind = params => {
    return axios.post(httpUrl + "/inspect-service/road/findRoad", params);
};
export const routeUpdate = params => {
    return axios.post(httpUrl + "/inspect-service/road/updateRoad", params);
};

//巡检记录
export const inspectRecord = params => {
    return axios.post(httpUrl + "/inspect-service/record/listPage", params);
};
export const inspectHistory = params => {
    return axios.post(httpUrl + "/inspect-service/inspectHistory/listPage", params);
};
export const exportRecord = params => {
    return axios.post(httpUrl + "/inspect-service/record/exportRecord", params);
};
export const inspectDetails = params => {
    return axios.post(httpUrl + "/inspect-service/record/findRecordData", params);
};
export const inspectDelRecord = params => {
    return axios.post(httpUrl + "/inspect-service/record/delRecord", params);
};

// 隐患管理
export const hiddenDangerList = params => {
    return axios.post(httpUrl + "/inspect-service/hiddenDanger/list", params);
};
export const hiddenDangerDetails = params => {
    return axios.post(httpUrl + "/inspect-service/hiddenDanger/details", params);
};

//统计管理
export const inspectRecordList = params => {
    return axios.post(httpUrl + "/monitor-service/gate/listPage", params);
};
export const inspectRecordExport = params => {
    return axios.post(httpUrl + "/monitor-service/gate/exportAttendance", params);
};
export const attendanceRecordList = params => {
    return axios.post(httpUrl + "/monitor-service/attendance/listPage", params);
};
export const attendanceRecordExport = params => {
    return axios.post(
        httpUrl + "/monitor-service/attendance/exportAttendance",
        params
    );
};

//系统配置
export const systemConfiguraList = params => {
    return axios.post(httpUrl + "/monitor-service/config/listPage", params);
};
export const systemConfiguraEdit = params => {
    return axios.post(httpUrl + "/monitor-service/config/updateConfig", params);
};
export const findConfig = params => {
    return axios.post(httpUrl + "/monitor-service/config/findConfig", params);
};

//统计分析
export const todayInspect = params => {
    return axios.post(
        httpUrl + "/inspect-service/inspectStatistics/todayInspect",
        params
    );
};
export const importRoad = params => {
    return axios.post(httpUrl + "/inspect-service/road/importRoad", params);
};
export const monthInspect = params => {
    return axios.post(
        httpUrl + "/inspect-service/inspectStatistics/monthInspect",
        params
    );
};
export const locationStatistics = params => {
    return axios.post(
        httpUrl + "/inspect-service/inspectStatistics/locationStatistics",
        params
    );
};
export const dangerStatistics = params => {
    return axios.post(
        httpUrl + "/inspect-service/inspectStatistics/dangerStatistics",
        params
    );
};
export const detailJsa = params => {
    return axios.post(httpUrl + "/work-service/jsaRecord/detailJsa", params);
};

// JSA分析
export const JsalistPage = params => {
    return axios.post(httpUrl + "/work-service/jsa/listPage", params);
};
export const delJsa = params => {
    return axios.post(httpUrl + "/work-service/jsa/delJsa", params);
};
export const addJsa = params => {
    return axios.post(httpUrl + "/work-service/jsa/addJsa", params);
};
export const updateJsa = params => {
    return axios.post(httpUrl + "/work-service/jsa/updateJsa", params);
};
export const importJsa = params => {
    return axios.post(httpUrl + "/work-service/jsa/importJsa", params);
};

// 作业审批库
export const taskListPage = params => {
    return axios.post(httpUrl + "/work-service/approvalDb/listPage", params);
};
export const delApprovalDb = params => {
    return axios.post(httpUrl + "/work-service/approvalDb/delApprovalDb", params);
};
export const userListPage = params => {
    return axios.post(httpUrl + "/monitor-service/user/listPage", params);
};
export const addApprovalDb = params => {
    return axios.post(httpUrl + "/work-service/approvalDb/addApprovalDb", params);
};
export const updateApprovalDb = params => {
    return axios.post(
        httpUrl + "/work-service/approvalDb/updateApprovalDb",
        params
    );
};
export const findApprovalDb = params => {
    return axios.post(
        httpUrl + "/work-service/approvalDb/findApprovalDb",
        params
    );
};
// 作业库安全措施
export const taskSafeListPage = params => {
    return axios.post(httpUrl + "/work-service/workSecurity/listPage", params);
};
export const addSecurity = params => {
    return axios.post(httpUrl + "/work-service/workSecurity/addSecurity", params);
};
export const delSecurity = params => {
    return axios.post(httpUrl + "/work-service/workSecurity/delSecurity", params);
};
export const updateSecurity = params => {
    return axios.post(
        httpUrl + "/work-service/workSecurity/updateSecurity",
        params
    );
};
export const importSecurity = params => {
    return axios.post(
        httpUrl + "/work-service/workSecurity/importSecurity",
        params
    );
};
// 风险辨识率
export const importRisk = params => {
    return axios.post(httpUrl + "/work-service/workRisk/importRisk", params);
};
export const riskListPage = params => {
    return axios.post(httpUrl + "/work-service/workRisk/listPage", params);
};
export const workAddRisk = params => {
    return axios.post(httpUrl + "/work-service/workRisk/addRisk", params);
};
export const workDelRisk = params => {
    return axios.post(httpUrl + "/work-service/workRisk/delRisk", params);
};
export const workUpdateRisk = params => {
    return axios.post(httpUrl + "/work-service/workRisk/updateRisk", params);
};
export const importEmergency = params => {
    return axios.post(
        httpUrl + "/work-service/workEmergency/importEmergency",
        params
    );
};
export const addEmergency = params => {
    return axios.post(
        httpUrl + "/work-service/workEmergency/addEmergency",
        params
    );
};
export const emergencyListPage = params => {
    return axios.post(httpUrl + "/work-service/workEmergency/listPage", params);
};
export const updateEmergency = params => {
    return axios.post(
        httpUrl + "/work-service/workEmergency/updateEmergency",
        params
    );
};

//用户管理
export const resetPwd = params => {
    return axios.post(httpUrl + "/monitor-service/user/resetPwd", params);
};
export const bindingPerson = params => {
    return axios.post(httpUrl + "/monitor-service/user/bindingPerson", params);
};
export const unbindPerson = params => {
    return axios.post(httpUrl + "/monitor-service/user/unbindPerson", params);
};
export const updateSkip = params => {
    return axios.post(httpUrl + "/monitor-service/user/updateSkin", params);
};

// 车辆通行管理
export const addUseRecord = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/addUseRecord", params);
};

// 获取当前发卡机
export const getMac = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/getDeviceSn", params);
};

// 下载二维码
export const downLoadFileExportQrCode = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/downloadQrCode", params);
};

// 访客车辆取卡--查询访客车辆信息
export const vehicleCarMessage= params =>{
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/query", params);
}

// 访客取卡--查询访客信息
export const vehiclePersonMessage= params =>{
    return axios.post(httpUrl + "/monitor-service/visitor/query", params);
}

export const readBarCode = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/readBarCode", params);
};
export const useRecordListPage = params => {
    return axios.post(
        httpUrl + "/monitor-service/vehicle/useRecordListPage",
        params
    );
};
export const jsaRecordPageList = params => {
    return axios.post(httpUrl + "/work-service/jsaRecord/listPage", params);
};
export const addJsaRecord = params => {
    return axios.post(httpUrl + "/work-service/jsaRecord/addJsaRecord", params);
};
export const delJsaRecord = params => {
    return axios.post(httpUrl + "/work-service/jsaRecord/delJsaRecord", params);
};

// jsa作业安全分析
export const updateJsaRecord = params => {
    return axios.post(
        httpUrl + "/work-service/jsaRecord/updateJsaRecord",
        params
    );
};

// 作业预约申请
export const applyListPage = params => {
    return axios.post(httpUrl + "/work-service/apply/listPage", params);
};
export const delApply = params => {
    return axios.post(httpUrl + "/work-service/apply/delApply", params);
};
export const importApply = params => {
    return axios.post(httpUrl + "/work-service/apply/importApply", params);
};
export const defaultApproval = params => {
    return axios.post(
        httpUrl + "/work-service/approvalDb/defaultApproval",
        params
    );
};
export const approvalDbListData = params => {
    return axios.post(httpUrl + "/work-service/approvalDb/listData", params);
};
export const submitApply = params => {
    return axios.post(httpUrl + "/work-service/apply/submitApply", params);
};
export const saveApply = params => {
    return axios.post(httpUrl + "/work-service/apply/saveApply", params);
};
export const contractorListPage = params => {
    return axios.post(httpUrl + "/monitor-service/contractor/listPage", params);
};
export const allPersonListPage = params => {
    return axios.post(httpUrl + "/monitor-service/allPerson/listPage", params);
};
export const findApply = params => {
    return axios.post(httpUrl + "/work-service/apply/findApply", params);
};
export const reservationListPage = params => {
    return axios.post(httpUrl + "/work-service/reservation/listPage", params);
};
export const addReservation = params => {
    return axios.post(httpUrl + "/work-service/reservation/addReservation", params);
};
export const delReservation = params => {
    return axios.post(httpUrl + "/work-service/reservation/delReservation", params);
};
export const updateReservation = params => {
    return axios.post(httpUrl + "/work-service/reservation/updateReservation", params);
};
export const importReservation = params => {
    return axios.post(httpUrl + "/work-service/reservation/importReservation", params);
};
export const importJsaRecord = params => {
    return axios.post(httpUrl + "/work-service/jsaRecord/importJsaRecord", params);
};
// 作业审批
export const workInfoListPage = params => {
    return axios.post(httpUrl + "/work-service/workInfo/listPage", params);
};
export const workInfoPendingList = params => {
    return axios.post(httpUrl + "/work-service/workInfo/pendingList", params);
};
export const workInfoFindWork = params => {
    return axios.post(httpUrl + "/work-service/workInfo/findWork", params);
};

//作业监控管理

export const workMDeviceListPage = params => {
    return axios.post(httpUrl + "/work-service/workMDevice/listPage", params);
};
export const importAiDevice = params => {
    return axios.post(httpUrl + "/work-service/aiDevice/importAiDevice", params);
};
export const aiDeviceListPage = params => {
    return axios.post(httpUrl + "/work-service/aiDevice/listPage", params);
};
export const delMDevice = params => {
    return axios.post(httpUrl + "/work-service/aiDevice/delMDevice", params);
};
export const addAiDevice = params => {
    return axios.post(httpUrl + "/work-service/aiDevice/addAiDevice", params);
};
export const updateAiDevice = params => {
    return axios.post(httpUrl + "/work-service/aiDevice/updateAiDevice", params);
};
export const importMDevice = params => {
    return axios.post(
        httpUrl + "/work-service/workMDevice/importMDevice",
        params
    );
};
export const workDictListPage = params => {
    return axios.post(httpUrl + "/work-service/workDict/listPage", params);
};
export const addMDevice = params => {
    return axios.post(httpUrl + "/work-service/workMDevice/addMDevice", params);
};
export const workMDeviceDelMDevice = params => {
    return axios.post(httpUrl + "/work-service/workMDevice/delMDevice", params);
};
export const updateMDevice = params => {
    return axios.post(
        httpUrl + "/work-service/workMDevice/updateMDevice",
        params
    );
};
export const workMAlarmListPage = params => {
    return axios.post(httpUrl + "/work-service/workMAlarm/listPage", params);
};
export const updateFP = params => {
    return axios.post(httpUrl + "/work-service/workMAlarm/updateFP", params);
};
export const delEmergency = params => {
    return axios.post(httpUrl + "/work-service/workEmergency/delEmergency", params);
};
export const rehearsalPlanList = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/listPage", params);
};
export const rehearsalRecordList = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalRecord/listPage", params);
};
export const delRehearsalRecords = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalRecord/delRehearsalRecords", params);
};
export const updateRehearsalRecord = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalRecord/updateRehearsalRecord", params);
};
export const rehearsalRecordInfo = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalRecord/findRehearsalPerson", params);
};
export const findRehearsalRecord = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalRecord/findRehearsalRecord", params);
};
export const addRehearsal = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/addRehearsal", params);
};
export const findRehearsal = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/findRehearsal", params);
};
export const updateRehearsal = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/updateRehearsal", params);
};
export const delRehearsal = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/delRehearsal", params);
};
export const importRehearsal = params => {
    return axios.post(httpUrl + "/monitor-service/rehearsalPlan/importRehearsal", params);
};


// 字典
export const taskdictMap = params => {
    return axios.post(httpUrl + "/work-service/workDict/dictMap", params);
};
export const workDictDelDict = params => {
    return axios.post(httpUrl + "/work-service/workDict/delDict", params);
};
export const workDictAddDict = params => {
    return axios.post(httpUrl + "/work-service/workDict/addDict", params);
};
export const workDictUpdateDict = params => {
    return axios.post(httpUrl + "/work-service/workDict/updateDict", params);
};
export const carList = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/carList", params);
};

// 添加公司
export const addCompany = params => {
    return axios.post(httpUrl + "/monitor-service/addCompany", params);
};

// 信标分组
export const beaconRailListPage = params => {
    return axios.post(httpUrl + "/monitor-service/beaconRail/listPage", params);
};
export const addBeaconRail = params => {
    return axios.post(httpUrl + "/monitor-service/beaconRail/addBeaconRail", params);
};
export const findBeaconRail = params => {
    return axios.post(httpUrl + "/monitor-service/beaconRail/findBeaconRail", params);
};
export const updateBeaconRail = params => {
    return axios.post(httpUrl + "/monitor-service/beaconRail/updateBeaconRail", params);
};
export const delBeaconRail = params => {
    return axios.post(httpUrl + "/monitor-service/beaconRail/delBeaconRail", params);
};
export const syncBeaconGroup = params => {
    return axios.get(httpUrl + "/monitor-service/beaconRail/syncBeaconGroup", params);
};
export const exportWorkTicket = params => {
    return axios.get(httpUrl + "/work-service/workInfo/exportWorkTicket", params);
};
export const saveLargeScreen = params => {
    return axios.post(httpUrl + "/monitor-service/saveLargeScreen", params);
};

export const facilityListPage = params => {
    return axios.post(httpUrl + "/monitor-service/facility/listPage", params);
};
export const addFacility = params => {
    return axios.post(httpUrl + "/monitor-service/facility/addFacility", params);
};
export const updateFacility = params => {
    return axios.post(httpUrl + "/monitor-service/facility/updateFacility", params);
};
export const findFacility = params => {
    return axios.post(httpUrl + "/monitor-service/facility/findFacility", params);
};
export const delFacility = params => {
    return axios.post(httpUrl + "/monitor-service/facility/delFacility", params);
};

export const facilityPerson = params => {
    return axios.post(httpUrl + "/monitor-service/railStatistics/facilityPerson", params);
};

// 权限分配
export const power = params => {
    return axios.post(httpUrl + "/monitor-service/role/findByRoleId", params);
};




// app菜单
export const getAppRouters = params => {
    return axios.get(httpUrl + "/monitor-service/menuApp/getAppRouters", params);
};



// 智能灯控
export const lampList = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/listPage", params);
};
export const delLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/delLampsIds", params);
};
export const importLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/importLamps", params);
};
export const findLampToId = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/findLamps", params);
};
export const addLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/addLamps", params);
};
export const changeLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/changeLamps", params);
};
export const updateLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/updateLamps", params);
};
export const lampsGroupList = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/listPage", params);
};
export const addLampsGroup = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/addLampsGroup", params);
};
export const updateLampsGroup = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/updateLampsGroup", params);
};
export const delLampsGroups = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/delLampsGroups", params);
};
export const LaGroupControl = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/LaGroupControl", params);
};
export const lampsLog = params => {
    return axios.post(httpUrl + "/monitor-service/lampsGroup/lampsLog", params);
};
export const lampsTimeListPage = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/lampsTimeListPage", params);
};
export const addLampsTimeCon = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/addLampsTimeCon", params);
};
export const updateLampsTime = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/updateLampsTime", params);
};
export const delLampsTimeIds = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/delLampsTimeIds", params);
};
export const lampsTimeLog = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/lampsTimeLog", params);
};
export const lampsAlarmList = params => {
    return axios.post(httpUrl + "/monitor-service/lampsAlarm/listPage", params);
};
export const disposeLaAlarm = params => {
    return axios.post(httpUrl + "/monitor-service/lampsAlarm/disposeLaAlarm", params);
};
export const lampsPullData = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/lampsPullData", params);
};
export const energyStatistics = params => {
    return axios.post(httpUrl + "/monitor-service/lampsStatistics/energyStatistics", params);
};
export const openLampsStatistics = params => {
    return axios.post(httpUrl + "/monitor-service/lampsStatistics/openLampsStatistics", params);
};
export const currentLampsStatus = params => {
    return axios.post(httpUrl + "/monitor-service/lampsStatistics/currentLampsStatus", params);
};
export const logCommandLamps = params => {
    return axios.post(httpUrl + "/monitor-service/lamps/logCommandLamps", params);
};
export const broadcastQuery = params => {
    return axios.get(httpUrl + "/monitor-service/lamps/broadcastQuery", params);
};
// 发卡机
export const cardDispenserList = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/listPage", params);
};
export const cardSenderPersonListPage = params => {
    return axios.post(httpUrl + "/monitor-service/cardSenderPerson/listPage", params);
};

export const cardSenderCarListPage = params => {
    return axios.post(httpUrl + "/monitor-service/cardDispenser/deviceCardSenderVehicle/listPage", params);
};

export const carRecordList = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/cardSenderVehicleLog", params);
};
// 车辆取卡
export const getCard = params => {
    return axios.post(httpUrl + "/monitor-service//vehicle/vehicleInfoVisitor/vehicleManualSendCard", params);
};

// 人员取卡
export const peopleGetCard = params => {
    return axios.post(httpUrl + "/monitor-service/visitor/ManualSendCard", params);
};

export const pushCmd = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/pushCmd", params);
};
export const AddCardDispenser = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/addCardSender", params);
};
export const EditCardDispenser = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/updateCardSender", params);
};
export const DelCardDispenser = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/delCardSender", params);
};
export const ImportCardDispenser = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/importCardSender", params, { responseType: 'blob' });
};
export const cardDispenserRecord = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/cardSenderLog", params);
};
export const getDeviceSnapPicture = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/getDeviceSnapPicture", params);
};
export const areaRecordList = params => {
    return axios.post(httpUrl + "/monitor-service/facilityAccess/listPage", params);
};
export const getDeptOnlineLogs = params => {
    return axios.post(httpUrl + "/monitor-service/personStatistics/getDeptOnlineLogs", params);
};
export const smsListPage = params => {
    return axios.post(httpUrl + "/monitor-service/sms/listPage", params);
};
export const getBroadcastList = params => {
    return axios.post(httpUrl + "/monitor-service/command/broadcastList", params);
};
export const batchBroadcast = params => {
    return axios.post(httpUrl + "/monitor-service/command/batchBroadcast", params);
};
export const addOrUpdata = params => {
    return axios.post(httpUrl + "/monitor-service/bloc/addOrUpdata", params);
};
export const getBlocInfo = params => {
    return axios.post(httpUrl + "/monitor-service/bloc/getBlocInfo", params);
};
export const childCompanyList = params => {
    return axios.post(httpUrl + "/monitor-service/branch/listPage", params);
};
export const childCompanyAdd = params => {
    return axios.post(httpUrl + "/monitor-service/branch/addBranch", params);
};
export const childCompanyEdit = params => {
    return axios.post(httpUrl + "/monitor-service/branch/updateBranch", params);
};
export const childCompanyDel = params => {
    return axios.post(httpUrl + "/monitor-service/branch/delBranch", params);
};
export const returnCard = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/returnCard", params);
};
export const returnCardPerson = params => {
    return axios.post(httpUrl + "/monitor-service/cardSenderPerson/returnCard", params);
};

export const returnCardCar = params => {
    return axios.post(httpUrl + "/monitor-service/cardDispenser/deviceCardSenderVehicle/returnCard", params);
};

export const getListDetail = params => {
    return axios.post(httpUrl + "/monitor-service/cardSender/getListDetail", params);
};
// 闸机
export const turnstileList = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/listPage", params);
};
export const Addturnstile = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/addGate", params);
};
export const Editturnstile = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/updateGate", params);
};
export const Delturnstile = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/delGate", params);
};
export const Importturnstile = params => {
    return axios.post(httpUrl + "/monitor-service/gateManage/importBuilding", params, { responseType: 'blob' });
};
export const BackSQLData = params => {
    return axios.post(httpUrl + "/monitor-service/backup/backSQLData", params);
};
export const BackSQLDataListPage = params => {
    return axios.post(httpUrl + "/monitor-service/backup/ListPage", params);
};

// 定位日志
export const cardLogListPage = params => {
    return axios.post(httpUrl + "/monitor-service/cardLog/listPage", params);
};
export const emptyConfig = params => {
    return axios.post(httpUrl + "/system/alarm/notice/sos/emptyConfig", params);
};
// 应急区域
export const emergencyAreaList = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/listPage", params);
};
export const emergencyAreaDetail = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/detail", params);
};
export const emergencyAreaExport = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/export", params);
};
export const emergencyAreaImport = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/batchImport", params);
};
export const emergencyAreaAdd = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/create", params);
};
export const emergencyAreaDelete = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/delete", params);
};
export const emergencyAreaUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/emergencyArea/update", params);
};
// 租户数据源
export const tenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/listPage", params);
};
export const addTenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/create", params);
};
export const updateTenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/update", params);
};
export const exportTenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/export", params);
};
export const importTenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/batchImport", params);
};
export const deleteTenantDatasource = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenantDatasource/delete", params);
};
// 租户管理
export const tenantList = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/listPage", params);
};
export const addTenant = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/create", params);
};
export const updateTenant = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/update", params);
};
export const exportTenant = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/export", params);
};
export const importTenant = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/batchImport", params);
};
export const deleteTenant = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/delete", params);
};
export const authAndInit = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/authAndInit", params);
};
export const authInfo = params => {
    return axios.post(httpUrl + "/monitor-service/systemTenant/authInfo", params);
};
// sass大屏统计接口
export const findPersonCountStatistics = params => {
    return axios.post(httpUrl + "/monitor-service/blocStatistics/findPersonCountStatistics", params);
};
export const findOnlinePersonAndAlarmStatistics = params => {
    return axios.post(httpUrl + "/monitor-service/blocStatistics/findOnlinePersonAndAlarmStatistics", params);
};
export const findPersonAlarmInfoStatistics = params => {
    return axios.post(httpUrl + "/monitor-service/blocStatistics/findPersonAlarmInfoStatistics", params);
};

// 车辆管理改版
export const vehicleInfoListPage = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleInfo/listPage", params);
};
export const vehicleInfoUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleInfo/update", params);
};
export const vehicleInfoCreate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleInfo/create", params);
};
export const vehicleInfoDelete = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleInfo/delete", params);
};
export const vehicleInfoBatchImport = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleInfo/batchImport", params);
};
export const vehicleHistoryPositionQueryList = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleHistoryPosition/queryList", params);
};
export const vehicleAlarmSettingListPage = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarmSetting/listPage", params);
};
export const vehicleAlarmSettingCreate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarmSetting/create", params);
};
export const vehicleAlarmSettingUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarmSetting/update", params);
};
export const vehicleAlarmSettingDelete = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarmSetting/delete", params);
};
export const carVehicleAlarmListPage = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarm/listPage", params);
};
export const carVehicleAlarmDispose = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarm/dispose", params);
};
export const vehicleAlarmSettingDetail = params => {
    return axios.post(httpUrl + "/monitor-service/vehicleAlarmSetting/detail", params);
};
export const vehicleInfoVisitorListPage = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/listPage", params);
};
export const vehicleInfoVisitorCreate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/create", params);
};
export const vehicleInfoVisitorUpdate = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/update", params);
};
export const vehicleInfoVisitorDelete = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/delete", params);
};
export const vehicleInfoVisitorExport = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/export", params);
};
export const vehicleInfoVisitorLeave = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/leave", params);
};
export const vehicleInfoVisitorBatchImport = params => {
    return axios.post(httpUrl + "/monitor-service/vehicle/vehicleInfoVisitor/batchImport", params);
};


// WEBPACK FOOTER //
// ./src/api/api.js